export default "__VITE_ASSET__aae94c67__"